
export enum Value {
	BorderRadius = '1.8rem',
	BorderRadius_Field = '0.8rem',
	BorderRadius_Button = '0.8rem',
	BorderRadius_Tooltip = '0.8rem'
}
